import React, { useState } from "react";
import { ButtonVariant, Dialog } from "@merge-api/merge-javascript-shared";
import Dropzone from "../../../../shared/Dropzone";
import useCustomizationContext from "../context/useCustomizationContext";

type LogoUploadModalProps = {
  isModalOpen: boolean;
  onHide: () => void;
};

const LogoUploadModal = ({ isModalOpen, onHide }: LogoUploadModalProps) => {
  const [tempLogo, setTempLogo] = useState<File | null>(null);
  const { setLogo, setHasLogoChange } = useCustomizationContext();

  // HANDLERS
  const handleLogoUpload = (files: Array<File>) => {
    const logoFile = files[0];
    setTempLogo(logoFile);
  };

  return (
    <Dialog
      open={isModalOpen}
      onClose={onHide}
      variant="md"
      title="Reupload logo"
      primaryButtonText="Save"
      primaryButtonVariant={ButtonVariant.PrimaryGray}
      onPrimaryButtonClick={() => {
        setLogo(tempLogo); // only set actual logo once the save button is clicked
        setHasLogoChange(true);
        onHide();
      }}
    >
      <div className="flex flex-col gap-4">
        <div>
          <div className="font-semibold">Upload a square logo</div>
          <div className="text-gray-40 text-sm mb-1">
            Recommended 1:1 ratio and 1MB max file size
          </div>
          <Dropzone upload={handleLogoUpload} />
        </div>
      </div>
    </Dialog>
  );
};

export default LogoUploadModal;
